import { respondData } from "@/utils/"
import { awaitTo } from "datagent/src/utils/"
export default function ({ contact, models, origin = "develop" }) {
    return {
        beforeCreate() {
            this._MODELS = {};
            models.forEach(Model => {
                let opts = {}
                if(Model.constructor == Array) [Model,opts]=Model
                const modelName = Model.ModelName;
                this[`$${modelName}`] = new Model({ contact,...opts });
                this._MODELS[`${modelName}`] = Model;
            })
        },
        methods: {
            async $$active(MODEL_NAME, action, query, options = { origin }) {
                let result
                const $model = this[`$${MODEL_NAME}`];
                if (!$model) return Promise.reject(`The ${MODEL_NAME} model is empty!`);
                if (typeof $model[action] !== 'function'){
                    return Promise.reject(`The ${MODEL_NAME} model.${action} is not a function!`);
                }
                const { query: _query, options: _options } = await this.$$onRequestBefore(MODEL_NAME, action, { query, options });
                this.$$onRestfulBefore(MODEL_NAME, action)
                try {
                    result = await $model[action](_query, _options)
                    await this.$$onRestfulSuccess(MODEL_NAME, action, result);
                } catch (err) {
                    const [_err, _result] = await awaitTo(respondData()({ result: err }))
                    console.warn(_err)
                    result = _err
                    this.$$onRestfulError(MODEL_NAME, action, _err);
                    // throw new RequestError(err.message, err.response) //网络请求出错时
                }
                return result;
                // return $model[action](_query, _options)
                //     .then(
                //         result => {
                //             this.$$onRestfulSuccess(MODEL_NAME, 'fetch', result);
                //             return result;
                //         }
                //     ).catch(err => {
                //         this.$$onRestfulError(MODEL_NAME, 'fetch', err);
                //     });
            },

            $$onRequestBefore(modelName, method, ctx) {
                return ctx;
            },
            $$onRestfulBefore(modelName, method, ctx) {
                this.$$loading(modelName);
                this.$$loading(modelName+method);
                return ctx
            },
            $$onRestfulSuccess(modelName, method) {
                this.$$loaded(modelName);
                this.$$loaded(modelName+method);
            },
            $$onRestfulError(modelName, method, err) {
                this.$$loaded(modelName);
                this.$$loaded(modelName+method);
                this.$$error(err);
            },
            $$fetch(MODEL_NAME, query, options = { origin }) {
                return this.$$active(MODEL_NAME, 'fetch', query, options);
            },
            $$find(MODEL_NAME, id, options = { origin }) {
                return this.$$active(MODEL_NAME, 'find', { id }, options);
            },
            $$save(MODEL_NAME, data, options = { origin }) {
                return this.$$active(MODEL_NAME, 'save', data, options);
            },
            $$del(MODEL_NAME, id, options = { origin }) {
                return this.$$active(MODEL_NAME, 'destroy', { id }, options);
            },


        },
    }
}
